var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-row",
            { staticClass: "margin-top12" },
            [
              _c("el-row", { staticClass: "custom-item-text-row" }, [
                _c("span", { staticClass: "custom-item-text bl" }, [
                  _vm._v(_vm._s(_vm.$t("panel.theme_color"))),
                ]),
              ]),
              _c(
                "el-row",
                { staticClass: "custom-theme-color-button function-area" },
                [
                  _c(
                    "color-button",
                    {
                      staticClass: "margin-left2",
                      attrs: {
                        "color-type": "light",
                        label: _vm.overallSettingForm.panel.themeColor,
                      },
                      on: { onClick: _vm.colorButtonClick },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("panel.theme_color_light")) + "\n        "
                      ),
                    ]
                  ),
                  _c(
                    "color-button",
                    {
                      staticClass: "margin-left32",
                      attrs: {
                        "color-type": "dark",
                        label: _vm.overallSettingForm.panel.themeColor,
                      },
                      on: { onClick: _vm.colorButtonClick },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("panel.theme_color_dark")) + "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "margin-top20" },
            [
              _c("el-row", { staticClass: "custom-item-text-row" }, [
                _c("span", { staticClass: "custom-item-text bl" }, [
                  _vm._v(_vm._s(_vm.$t("panel.component_gap"))),
                ]),
              ]),
              _c(
                "el-row",
                { staticClass: "function-area" },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "mini" },
                      on: {
                        change: function ($event) {
                          return _vm.themeChange()
                        },
                      },
                      model: {
                        value: _vm.overallSettingForm.panel.gap,
                        callback: function ($$v) {
                          _vm.$set(_vm.overallSettingForm.panel, "gap", $$v)
                        },
                        expression: "overallSettingForm.panel.gap",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "yes" } }, [
                        _vm._v(_vm._s(_vm.$t("panel.gap"))),
                      ]),
                      _c("el-radio", { attrs: { label: "no" } }, [
                        _vm._v(_vm._s(_vm.$t("panel.no_gap"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "margin-top20" },
            [
              _c("el-row", { staticClass: "custom-item-text-row" }, [
                _c("span", { staticClass: "custom-item-text bl" }, [
                  _vm._v(" " + _vm._s(_vm.$t("panel.refresh_frequency"))),
                ]),
                _c(
                  "span",
                  { staticClass: "custom-item-text bl" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticClass: "el-input-refresh-loading",
                        on: { change: _vm.themeChange },
                        model: {
                          value: _vm.overallSettingForm.refreshViewEnable,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.overallSettingForm,
                              "refreshViewEnable",
                              $$v
                            )
                          },
                          expression: "overallSettingForm.refreshViewEnable",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("panel.enable_refresh_view")))]
                    ),
                  ],
                  1
                ),
                _c(
                  "span",
                  { staticClass: "custom-item-text br" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticClass: "el-input-refresh-loading",
                        on: { change: _vm.themeChange },
                        model: {
                          value: _vm.overallSettingForm.refreshViewLoading,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.overallSettingForm,
                              "refreshViewLoading",
                              $$v
                            )
                          },
                          expression: "overallSettingForm.refreshViewLoading",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("panel.enable_view_loading")))]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "el-row",
                { staticClass: "function-area" },
                [
                  _c("el-input", {
                    staticClass: "el-input-refresh-time",
                    attrs: {
                      type: "number",
                      size: "mini",
                      "controls-position": "right",
                      min: 1,
                      max: 3600,
                      disabled: !_vm.overallSettingForm.refreshViewEnable,
                    },
                    on: { change: _vm.themeChange },
                    model: {
                      value: _vm.overallSettingForm.refreshTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.overallSettingForm, "refreshTime", $$v)
                      },
                      expression: "overallSettingForm.refreshTime",
                    },
                  }),
                  _c(
                    "el-select",
                    {
                      staticClass: "el-input-refresh-unit margin-left8",
                      attrs: {
                        size: "mini",
                        disabled: !_vm.overallSettingForm.refreshViewEnable,
                      },
                      on: { change: _vm.themeChange },
                      model: {
                        value: _vm.overallSettingForm.refreshUnit,
                        callback: function ($$v) {
                          _vm.$set(_vm.overallSettingForm, "refreshUnit", $$v)
                        },
                        expression: "overallSettingForm.refreshUnit",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("panel.minute"),
                          value: "minute",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("panel.second"),
                          value: "second",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "margin-top20 margin-bottom20" },
            [
              _c("el-row", { staticClass: "custom-item-text-row" }, [
                _c("span", { staticClass: "custom-item-text bl" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("panel.panel_view_result_show")) +
                      "\n          "
                  ),
                  _c(
                    "span",
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: { effect: "dark", placement: "bottom" },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("panel.panel_view_result_tips")
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                          _c("i", {
                            staticClass: "el-icon-info",
                            staticStyle: { cursor: "pointer" },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "el-row",
                { staticClass: "function-area" },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "radio-span",
                              attrs: { size: "mini" },
                              on: { change: _vm.themeChange },
                              model: {
                                value: _vm.overallSettingForm.panel.resultMode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.overallSettingForm.panel,
                                    "resultMode",
                                    $$v
                                  )
                                },
                                expression:
                                  "overallSettingForm.panel.resultMode",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "all" } }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("panel.view"))),
                                ]),
                              ]),
                              _c("el-radio", { attrs: { label: "custom" } }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("panel.panel")) + " "),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "slider-area", attrs: { span: 8 } },
                        [
                          _c("el-slider", {
                            staticStyle: { "margin-left": "5px" },
                            attrs: {
                              disabled:
                                _vm.overallSettingForm.panel.resultMode ===
                                "all",
                              "show-input": "",
                              "show-input-controls": false,
                              "show-tooltip": false,
                              "input-size": "mini",
                              min: 1,
                              max: 10000,
                            },
                            on: { change: _vm.themeChange },
                            model: {
                              value: _vm.overallSettingForm.panel.resultCount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.overallSettingForm.panel,
                                  "resultCount",
                                  $$v
                                )
                              },
                              expression:
                                "overallSettingForm.panel.resultCount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }